import { ArrowLeft } from 'lucide-react';
import { Link, useSearchParams } from 'react-router-dom';
import { tx } from '../i18n';

/** Stripe cancel_url landing: nothing was charged, so send them straight back. */
export default function CheckoutCancelledPage() {
  const [searchParams] = useSearchParams();
  const postcode = searchParams.get('postcode');

  return (
    <div className="page page--narrow">
      <section className="card stack stack--tight">
        <h1 className="card__title">{tx('Checkout cancelled', 'Ödeme iptal edildi',
    'Płatność anulowana',
    'Pagamento cancelado',
    'Pago cancelado')}</h1>
        <p className="muted">
          {tx(
            `Nothing was charged. Your free report${postcode ? ` for ${postcode}` : ''} is still there whenever you want it.`,
            `Hiçbir ücret alınmadı. ${postcode ? `${postcode} için ` : ''}ücretsiz raporunuz istediğiniz zaman burada.`,
    `Nic nie zostało pobrane. Twój bezpłatny raport${postcode ? ` dla ${postcode}` : ''} nadal czeka, kiedy tylko zechcesz.`,
    `Não foi cobrado nada. O seu relatório gratuito${postcode ? ` de ${postcode}` : ''} continua lá quando quiser.`,
    `No se ha cobrado nada. Tu informe gratuito${postcode ? ` de ${postcode}` : ''} sigue ahí cuando quieras.`,
          )}
        </p>
        <Link to="/" className="button" style={{ alignSelf: 'flex-start' }}>
          <ArrowLeft size={16} aria-hidden="true" />
          {tx('Back to search', 'Aramaya dön',
    'Wróć do wyszukiwania',
    'Voltar à pesquisa',
    'Volver a la búsqueda')}
        </Link>
      </section>
    </div>
  );
}
